const CONTENT = `
    ... on ElementContent {
        id
        title
        html
        secondaryHTML
    } `;

export default CONTENT;
